import { endPoints, requestType } from "../../constants/Variables";
import Api from "../index";

const getAppointmentDetail = (id) => {
    return Api(`${endPoints.getAppointmentDetail}/${id}`, null, requestType.GET);
  };

export { getAppointmentDetail };